import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    minHeight: 'calc(100vh - 100px)', /* this roughly makes all pages come out right */
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    background: theme.palette.grey[100],
  },
}))
